import theme from '@totallymoney/ui/theme'

import TooltipButton from '@components/TooltipButton'

export type Content = {
    ariaDescription: string
    ariaLabel: string
    description: string
    title: string
}

interface CellTooltipProps {
    content: Content
    onPress: (content: Content) => void
}

const CellTooltip = ({ content, onPress }: CellTooltipProps) => {
    return (
        <TooltipButton
            aria-label={content.ariaLabel}
            aria-description={content.ariaDescription}
            onPress={() => onPress(content)}
            color={theme.grey120}
            title={`Tooltip icon for ${content.title}`}
        />
    )
}

export default CellTooltip
